import { Store } from 'src/store/index';
import getFormatSelectorValues from './getFormatSelectorValues';

const getFormatSelectorValue = (store: Store, typeName: string) => getFormatSelectorValues(store)[typeName];

export default getFormatSelectorValue;
